import React from 'react';
import { Form, Input } from 'antd';
import './style.scss'
import { CommonService } from 'services/CommonService';

const InputAntd = ({ placeholder, customClass, name, isRequired, isPhoneNumber, isPassword, onlyNumber, onEnter, minLength }) => {

  let rules = [];
  if (isRequired) {
    rules = [
      {
        required: true,
        message: 'Trường bắt buộc không được để trống',
      },
      ...rules,
    ]
  }
  if (isPhoneNumber) {
    rules = [
      {
        pattern: CommonService.REGEX_PHONE_NUMBER,
        message: 'Số điện thoại không đúng định dạng',
      },
      ...rules,
    ]
  }
  if (minLength) {
    rules = [
      { min: minLength, message: `Tối thiểu ${minLength} kí tự!` },
      ...rules,
    ]
  }

  return (
    <Form.Item className={`input-common ${customClass || ''}`}>
      <Form.Item name={name} noStyle rules={rules}>
        <Input
          placeholder="&nbsp;"
          className="custom-input"
          type={isPassword ? 'password' : isPhoneNumber || onlyNumber ? 'number' : 'text'}
          onPressEnter={onEnter}
          // min={minLength || 0}
        />
      </Form.Item>
      <span className="input-common__placeholder">{placeholder}</span>
    </Form.Item>
  );
}

InputAntd.defaultProps = {
  isRequired: true,
};

export default React.memo(InputAntd);